// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'

import moment from 'moment'
import store from '@/vuex/store.js'
import router from '@/router'
import VueGtag from 'vue-gtag'
import VueQuillEditor from 'vue-quill-editor'
// Importe os estilos do Quill (Escolha entre os temas 'snow' ou 'bubble')
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import Quill from 'quill'
import quillTable from 'quill-table'
import 'quill-table/src/css/quill.table.css'
import TableAwareHistory from '@/utils/quill-table-history'
import QuillTableMenu from '@/utils/quill-table-menu'
import SafeClipboard from '@/utils/quill-safe-clipboard'

// Registrando as dependências da tabela no Quill
Quill.register(quillTable.TableCell)
Quill.register(quillTable.TableRow)
Quill.register(quillTable.Table)
Quill.register(quillTable.Contain)
Quill.register('modules/table', quillTable.TableModule)
Quill.register('modules/history', TableAwareHistory)
Quill.register('modules/table-menu', QuillTableMenu)
Quill.register('modules/clipboard', SafeClipboard, true)

// Links do despacho: abrem em nova janela e URLs sem protocolo que parecem
// domínio (ex.: www.u.gov.br) ganham https:// na frente — sem isso o Quill
// nativo geraria um link RELATIVO que quebra ao clicar.
const Link = Quill.import('formats/link')
class LinkAbreNovaJanela extends Link {
  static sanitize (url) {
    // ATENÇÃO: delegar via super e não `Link.<static>` — o create() nativo
    // chama `this.sanitize` com `this` = classe chamadora; chamando
    // `Link.create` direto o sanitize da subclass é BYPASSADO.
    if (url && !/^[a-zA-Z][\w+\-.]*:/.test(url) && /^(www\.|\w[\w-]*\.[a-zA-Z]{2,})/.test(url)) {
      url = 'https://' + url
    }
    return super.sanitize(url)
  }

  static create (value) {
    const node = super.create(value)
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
    return node
  }

  static formats (domNode) {
    // O retorno de formats() é diretamente o valor do format 'link'.
    // Deve continuar sendo a string da URL; target/rel vivem apenas no DOM.
    return super.formats(domNode)
  }
}
Quill.register(LinkAbreNovaJanela, true)

import App from '@/app'

moment.locale('pt-br')
Vue.prototype.moment = moment

Vue.use(Vuetify)
Vue.use(Vuelidate)

Vue.use(VueTheMask)

Vue.use(VueGtag, {
  config: {
    id: 'G-0FTQYC6381'
  }
}, router)
Vue.use(VueQuillEditor)

require('@/../node_modules/vuetify/dist/vuetify.min.css')
require('@/../node_modules/animate.css/animate.min.css')
require('@/../node_modules/font-awesome/css/font-awesome.min.css')

/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  template: '<app/>',
  components: { App }
})
